import { ProjectForm } from "./form"

export const ProjectCreate = () => {
    return <ProjectForm />
}